import { z } from 'zod'

/**
 * Zod schema for user profile form validation
 */
export const userProfileFormSchema = z.object({
  // Personal info fields
  display_name: z
    .string()
    .min(1, 'Display name is required')
    .max(255, 'Display name must be 255 characters or less'),
  phone: z
    .string()
    .max(30, 'Phone number must be 30 characters or less')
    .optional()
    .or(z.literal('')),
  job_title: z
    .string()
    .max(100, 'Job title must be 100 characters or less')
    .optional()
    .or(z.literal('')),
  timezone: z
    .string()
    .min(1, 'Timezone is required'),

  // Notification preferences
  notification_preferences: z.object({
    email: z.boolean().optional().default(true),
    sms: z.boolean().optional().default(false),
  }).optional(),

  // UI preferences (optional for future use)
  ui_preferences: z.record(z.unknown()).optional(),
})

// Input type for form defaultValues
export type UserProfileFormInput = z.input<typeof userProfileFormSchema>

// Output type after validation/parsing
export type UserProfileFormValues = z.output<typeof userProfileFormSchema>

// Default values for user profile form
export const userProfileFormDefaults: UserProfileFormInput = {
  display_name: '',
  phone: '',
  job_title: '',
  timezone: 'America/New_York',
  notification_preferences: {
    email: true,
    sms: false,
  },
  ui_preferences: {},
}
